import { useDispatch, useSelector } from "react-redux";
import { setAnalyticsOverview, setAnalyticsTimeframe } from "../context";
import { useEffect, useState } from "react";
import { GroupAnalyticsService } from "../services/group-analytics.service";
import { axiosInstance } from "lib/axios";

export function useGroupAnalytics() {
  const analyticsService = new GroupAnalyticsService(axiosInstance);
  const dispatch = useDispatch();
  const { analyticsTimeframe, analyticsOverview } = useSelector(
    (state) => state.group
  );
  const [overviewDataError, setOverviewDataError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setOverviewDataError(null);
      setLoading(true);
      try {
        const data = await analyticsService.getAnalyticsOverviewData(
          analyticsTimeframe
        );
        dispatch(setAnalyticsOverview(data));
      } catch (error) {
        setOverviewDataError(error);
        dispatch(setAnalyticsOverview([]));
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [analyticsTimeframe]);

  return {
    analyticsOverview,
    loading,
    overviewDataError,
    timeframe: analyticsTimeframe,
    setTimeframe: (timeframe) => {
      dispatch(setAnalyticsTimeframe(timeframe));
    },
  };
}
